import { useEffect } from "react";
import { useAuth } from "@clerk/clerk-react";
import { Outlet, useNavigate, NavLink } from "react-router-dom";
import DashboardNav from "@/components/navigation/DashboardNav";
import ErrorBoundary from "@/components/ui/ErrorBoundary";
import { NAV_ITEMS } from "@/constants/navigation";
import { SchoolProvider } from "@/context/SchoolContext";

export default function DashboardLayout() {
  const { userId, isLoaded } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoaded && !userId) {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoaded, userId]);

  if (!isLoaded || !userId) {
    return (
      <div className="h-[50vh] flex items-center justify-center">
        <div className="w-7 h-7 rounded-full border-[2.5px] border-border border-t-primary animate-spin" />
      </div>
    );
  }

  return (
    <SchoolProvider>
      <div className="flex flex-col min-h-screen">
        {/* Top Nav */}
        <DashboardNav />

        {/* Main Content */}
        <main className="flex-1 min-w-0 max-md:pb-16">
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </main>

        {/* Mobile Bottom Nav - shares NAV_ITEMS with DashboardNav, cannot diverge */}
        <nav className="fixed bottom-0 left-0 right-0 h-[62px] bg-background border-t border-border flex items-center justify-around z-50 px-1 md:hidden">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === "/dashboard"}
              className={({ isActive }) =>
                `flex flex-col items-center gap-[0.2rem] px-[0.6rem] py-[0.4rem] rounded-lg text-[0.625rem] font-medium no-underline transition-colors min-w-[48px] text-center ${
                  isActive ? "text-primary" : "text-muted-foreground"
                }`
              }
            >
              <item.icon size={20} />
              <span>{item.short}</span>
            </NavLink>
          ))}
        </nav>
      </div>
    </SchoolProvider>
  );
}
